import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";

interface CreateAcquisitionResult {
  acquisitionId: string;
  name: string;
  status: string;
}

export const useCreateAcquisition = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const createAcquisition = async (params: {
    name: string;
    subsidiary: string;
    subsidiaryId: string;
    jiraTicket?: string;
    comment?: string;
  }): Promise<CreateAcquisitionResult | null> => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(`${API_URL}/acquisition-imports`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
      });
      return (await checkResponse(response)) as CreateAcquisitionResult;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to create acquisition.";
      setError(message);
      console.error("Error creating acquisition:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { createAcquisition, loading, error, setError };
};
